import {app} from "../app";

class ResponsiveDirective implements ng.IDirective {

    private window:ng.IWindowService;

    private attribute:string;
    private directive:string;
    private resolutionFrom:number;
    private resolutionTo:number;

    restrict = 'A';

    static attributes = [
        'Src',
        'Show',
        'Hide'
    ];

    constructor($window:ng.IWindowService, attribute:string, directive:string, resolutionFrom:number, resolutionTo:number) {
        this.window         = $window;
        this.attribute      = attribute;
        this.directive      = directive;
        this.resolutionFrom = resolutionFrom;
        this.resolutionTo   = resolutionTo;
    }

    link = (scope:ng.IScope, element:ng.IAugmentedJQuery, attrs:ng.IAttributes, ctrl:any) => {
        const execute = () => {
            const fn        = this['switch' + this.attribute],
                  reverseFn = this['reverseSwitch' + this.attribute];

            if ((!this.resolutionFrom || this.resolutionFrom <= this.window.innerWidth) && (!this.resolutionTo || this.resolutionTo >= this.window.innerWidth)) {
                if (typeof fn === 'function') {
                    fn.apply(this, [element, attrs]);
                }

                return;
            }

            if (typeof reverseFn === 'function') {
                reverseFn.apply(this, [element, attrs]);
            }
        };

        attrs.$observe(this.directive, () => {
            execute();
        });

        angular.element(this.window).resize(() => {
            execute();
        });
    };

    private switchSrc(element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
        if (!attrs[this.directive] || attrs[this.directive].length <= 0) {
            return;
        }

        attrs.$set(this.attribute.toLocaleLowerCase(), attrs[this.directive]);
    }

    private switchHide(element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
        element.show();
    }

    private reverseSwitchHide(element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
        this.switchShow(element, attrs);
    }

    private switchShow(element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
        element.hide();
    }

    private reverseSwitchShow(element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
        this.switchHide(element, attrs);
    }

    static factory(attribute:string, directive:string, resolutionFrom:number, resolutionTo:number):ng.IDirectiveFactory {
        const _directive   = ($window:ng.IWindowService) => new this($window, attribute, directive, resolutionFrom, resolutionTo);
        _directive.$inject = ['$window'];
        return _directive;
    }

}

const breakpoints = [
    {
        shortName     : 'xs',
        fullName      : 'phone',
        resolutionFrom: 0,
        resolutionTo  : 479,
    },
    {
        shortName     : 'sm',
        fullName      : 'tablet',
        resolutionFrom: 480,
        resolutionTo  : 767,
    },
    {
        shortName     : 'md',
        fullName      : 'desktop',
        resolutionFrom: 768,
        resolutionTo  : 991,
    },
    {
        shortName     : 'lg',
        fullName      : 'lgDesktop',
        resolutionFrom: 992,
        resolutionTo  : 1200,
    },
    {
        shortName     : 'xsMin',
        fullName      : 'phoneMin',
        resolutionFrom: 0,
        resolutionTo  : null,
    },
    {
        shortName     : 'smMin',
        fullName      : 'tabletMin',
        resolutionFrom: 480,
        resolutionTo  : null,
    },
    {
        shortName     : 'mdMin',
        fullName      : 'desktopMin',
        resolutionFrom: 768,
        resolutionTo  : null,
    },
    {
        shortName     : 'lgMin',
        fullName      : 'lgDesktopMin',
        resolutionFrom: 992,
        resolutionTo  : null,
    },
    {
        shortName     : 'xsMax',
        fullName      : 'phoneMax',
        resolutionFrom: null,
        resolutionTo  : 479,
    },
    {
        shortName     : 'smMax',
        fullName      : 'tabletMax',
        resolutionFrom: null,
        resolutionTo  : 767,
    },
    {
        shortName     : 'mdMax',
        fullName      : 'desktopMax',
        resolutionFrom: null,
        resolutionTo  : 991,
    },
    {
        shortName     : 'lgMax',
        fullName      : 'lgDesktopMax',
        resolutionFrom: null,
        resolutionTo  : 1200,
    },
];

for (let breakpoint of breakpoints) {
    for (let attribute of ResponsiveDirective.attributes) {
        const directive = breakpoint.fullName + attribute;
        app.directive(
            directive,
            ResponsiveDirective.factory(
                attribute, directive, breakpoint.resolutionFrom, breakpoint.resolutionTo
            )
        );
    }
}

// -------------------------------------------------------------------
// Directive Comments: Src
// -------------------------------------------------------------------

/**
 * @ngdoc directive
 * @name phoneSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name phoneMinSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletMinSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopMinSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopMinSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name phoneMaxSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletMaxSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopMaxSrc
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopMaxSrc
 * @restrict A
 * @priority 100
 */

// -------------------------------------------------------------------
// Directive Comments: Show
// -------------------------------------------------------------------

/**
 * @ngdoc directive
 * @name phoneShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name phoneMinShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletMinShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopMinShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopMinShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name phoneMaxShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletMaxShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopMaxShow
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopMaxShow
 * @restrict A
 * @priority 100
 */

// -------------------------------------------------------------------
// Directive Comments: Hide
// -------------------------------------------------------------------

/**
 * @ngdoc directive
 * @name phoneHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name phoneMinHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletMinHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopMinHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopMinHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name phoneMaxHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name tabletMaxHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name desktopMaxHide
 * @restrict A
 * @priority 100
 */

/**
 * @ngdoc directive
 * @name lgDesktopMaxHide
 * @restrict A
 * @priority 100
 */
